import React, { useContext, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
    H_CATCHMENT_MODULE,
    H_DISTRIBUTION_MODULE,
    H_HYDRO_MODULE,
    H_INSTALLATION_MODULE,
    H_PIEZO_MODULE,
    H_PLUVIO_MODULE,
    H_PRODUCTION_MODULE,
    H_QUALITO_MODULE,
    H_RESOURCE_MODULE,
} from '../../../../../account/constants/AccessRulesConstants'
import { componentHasHabilitations } from '../../../../../utils/HabilitationUtil'
import NetworkAction from 'referencial/components/network/actions/NetworkAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import { Grid } from '@mui/material'
import HabilitationQualito from './habilitations/HabilitationQualito'
import HabilitationPiezo from './habilitations/HabilitationPiezo'
import HabilitationHydro from './habilitations/HabilitationHydro'
import HabilitationPluvio from './habilitations/HabilitationPluvio'
import HabilitationInstallation from './habilitations/HabilitationInstallation'
import HabilitationProduction from './habilitations/HabilitationProduction'
import HabilitationDistribution from './habilitations/HabilitationDistribution'
import HabilitationResouce from './habilitations/HabilitationResource'
import HabilitationCatchment from './habilitations/HabilitationCatchment'
import { ModuleHabsContext } from 'administration/components/modules/AdminModulesApp'
import useActions from 'utils/customHook/useActions'

const UserAccessPanel = () => {
    const {
        networks,
        contributors,
    } = useSelector(store => ({
        networks: store.NetworkReducer.networks,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const moduleHabs = useContext(ModuleHabsContext)

    const dispatch = useDispatch()

    useActions(() => [], [])

    useEffect(() => {
        if (!networks.length) {
            dispatch(NetworkAction.fetchNetworks())
        }
        if (!contributors.length) {
            dispatch(ContributorAction.fetchContributors())
        }
    }, [])

    return (
        <Grid container spacing={1}>
            {componentHasHabilitations(H_QUALITO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationQualito />
                </Grid>
            )}
            {componentHasHabilitations(H_PIEZO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationPiezo />
                </Grid>
            )}
            {componentHasHabilitations(H_HYDRO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationHydro />
                </Grid>
            )}
            {componentHasHabilitations(H_PLUVIO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationPluvio />
                </Grid>
            )}
            {componentHasHabilitations(H_INSTALLATION_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationInstallation />
                </Grid>
            )}
            {componentHasHabilitations(H_PRODUCTION_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationProduction />
                </Grid>
            )}
            {componentHasHabilitations(H_DISTRIBUTION_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationDistribution />
                </Grid>
            )}
            {componentHasHabilitations(H_RESOURCE_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationResouce />
                </Grid>
            )}
            {componentHasHabilitations(H_CATCHMENT_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid size={12}>
                    <HabilitationCatchment />
                </Grid>
            )}
        </Grid>
    )
}

export default UserAccessPanel
